import { Checkbox } from "shared";
import {
    ComponentTypes,
    ITemplateComponent,
    ITemplateHrPersonComponent
} from "entities/template";
import React from "react";
import { useComponentsTranslations } from "../../../../lib/i18n";
import { FieldList } from "../../form_fields/field_list/field_list";
import { VisibilityField } from "../../form_fields/visibility_field/visibility_field";
import { BusinessGroups } from "../../form_fields/business_groups/business_groups";
import { LabelField } from "../../form_fields/label_field/label_field";
import { TooltipField } from "../../form_fields/tooltip_field/tooltip_field";
import styles from "./component_form_employee.module.scss";

interface IComponentFormEmployeeProps {
    component: ITemplateHrPersonComponent;
    enLanguageEnabled: boolean;
    componentList: ITemplateComponent[];
    triggerValidate: number;
    onChange: (component: ITemplateComponent) => void;
}

export const ComponentFormEmployee: React.FC<IComponentFormEmployeeProps> = React.memo(({
                                                                                            component,
                                                                                            enLanguageEnabled,
                                                                                            triggerValidate,
                                                                                            componentList,
                                                                                            onChange
                                                                                        }) => {
    const t = useComponentsTranslations();

    const onFieldChange = (value: Partial<ITemplateHrPersonComponent>) => {
        onChange({
            ...component,
            ...value
        })
    }

    return <div className={styles.container}>
        <LabelField component={component}
                    enLanguageEnabled={enLanguageEnabled}
                    title={t("formLabel")}
                    name="label-dynamic-input"
                    onChange={onFieldChange}/>
        <FieldList
            type={ComponentTypes.hrPerson}
            suffix={component.suffix}
            triggerValidate={triggerValidate}
            required={true}
            fieldList={component.fieldsList}
            onChange={onFieldChange}/>
        <BusinessGroups
            limitToBusinessGroups={component.limitToBusinessGroups}
            onChange={(value) => onFieldChange({ limitToBusinessGroups: value })}/>
        <VisibilityField
            component={component}
            componentList={componentList}
            onChange={onFieldChange}/>
        <TooltipField
            component={component}
            enLanguageEnabled={enLanguageEnabled}
            onChange={onFieldChange}
        />
        <div className={styles.checkboxGroup}>
            <Checkbox
                label={t("requiredField")}
                size="m"
                onChange={() => onFieldChange({ required: typeof component.required === "boolean" ? !component.required : false })}
                checked={typeof component.required === "boolean" ? component.required : true}
            />
            <Checkbox
                label={t("readonlyField")}
                size="m"
                onChange={() => onFieldChange({ readonly: !component.readonly })}
                checked={component.readonly}
            />
        </div>
    </div>;
});
